/**
 * Tam çerçeve / içerik slaytları: yalnızca görünür slayttaki video oynasın.
 * Gizli slaytlardaki videolar decode + ağ yükünü ikiye katlıyordu.
 * Ürün carousel'indeki data-video-carousel öğelerine dokunulmaz.
 */
import { SlideshowSelectEvent } from '@theme/events';

/**
 * @param {Element} slideshow
 */
function syncSlideshowVideos(slideshow) {
  if (!slideshow?.querySelectorAll) return;

  slideshow.querySelectorAll('slideshow-slide').forEach((slide) => {
    const video = slide.querySelector('video.slide__video');
    if (!(video instanceof HTMLVideoElement)) return;

    const hidden = slide.getAttribute('aria-hidden') === 'true';
    if (hidden) {
      video.pause();
    } else {
      video.play().catch(() => {});
    }
  });
}

/**
 * @param {Event} event
 */
function onSlideshowSelect(event) {
  const slideshow = event.target?.closest?.('slideshow-component');
  if (!slideshow || slideshow.hasAttribute('data-video-carousel')) return;
  syncSlideshowVideos(slideshow);
}

function initSlideshowVideos() {
  document.querySelectorAll('slideshow-component:not([data-video-carousel])').forEach((el) => {
    syncSlideshowVideos(el);
  });
}

document.addEventListener(SlideshowSelectEvent.eventName, onSlideshowSelect);

document.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(() => {
    initSlideshowVideos();
    requestAnimationFrame(initSlideshowVideos);
  });
});

document.addEventListener('shopify:section:load', () => {
  requestAnimationFrame(initSlideshowVideos);
});
